/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ApproveBigCommerceRequest,
  ApproveShopifyRequest,
  BigCommerceConfig,
  BigCommerceCustomerGroupsResponse,
  BigCommerceHealthcheckRequest,
  BigCommerceHealthcheckResult,
  BigCommerceProductSearchResponse,
  CompanyIntegrations,
  ConfigRepairPreview,
  CreateNetSuiteIntegrationRequest,
  DeleteIntegrationRequest,
  DisconnectBigCommerceRequest,
  DiscoverShopifyMetafieldsRequest,
  MaskedCompanyIntegration,
  RepairConfigRequest,
  ReplaceNetSuiteCredentialsRequest,
  ShopifyConfig,
  ShopifyCustomerTagsRequest,
  ShopifyCustomerTagsResponse,
  ShopifyHealthcheckRequest,
  ShopifyHealthcheckResult,
  ShopifyMetafieldDiscovery,
  ShopifyStoreLocationsRequest,
  ShopifyStoreLocationsResponse,
  TestIntegrationRequest,
  TestIntegrationResponse,
  TestNetSuiteConnectionRequest,
  UpdateBigCommerceFreightSettingsRequest,
  UpdateNetSuiteIntegrationRequest,
  UpdateShopifySettingsRequest,
} from "../models/index";
import {
  ApproveBigCommerceRequestFromJSON,
  ApproveBigCommerceRequestToJSON,
  ApproveShopifyRequestFromJSON,
  ApproveShopifyRequestToJSON,
  BigCommerceConfigFromJSON,
  BigCommerceConfigToJSON,
  BigCommerceCustomerGroupsResponseFromJSON,
  BigCommerceCustomerGroupsResponseToJSON,
  BigCommerceHealthcheckRequestFromJSON,
  BigCommerceHealthcheckRequestToJSON,
  BigCommerceHealthcheckResultFromJSON,
  BigCommerceHealthcheckResultToJSON,
  BigCommerceProductSearchResponseFromJSON,
  BigCommerceProductSearchResponseToJSON,
  CompanyIntegrationsFromJSON,
  CompanyIntegrationsToJSON,
  ConfigRepairPreviewFromJSON,
  ConfigRepairPreviewToJSON,
  CreateNetSuiteIntegrationRequestFromJSON,
  CreateNetSuiteIntegrationRequestToJSON,
  DeleteIntegrationRequestFromJSON,
  DeleteIntegrationRequestToJSON,
  DisconnectBigCommerceRequestFromJSON,
  DisconnectBigCommerceRequestToJSON,
  DiscoverShopifyMetafieldsRequestFromJSON,
  DiscoverShopifyMetafieldsRequestToJSON,
  MaskedCompanyIntegrationFromJSON,
  MaskedCompanyIntegrationToJSON,
  RepairConfigRequestFromJSON,
  RepairConfigRequestToJSON,
  ReplaceNetSuiteCredentialsRequestFromJSON,
  ReplaceNetSuiteCredentialsRequestToJSON,
  ShopifyConfigFromJSON,
  ShopifyConfigToJSON,
  ShopifyCustomerTagsRequestFromJSON,
  ShopifyCustomerTagsRequestToJSON,
  ShopifyCustomerTagsResponseFromJSON,
  ShopifyCustomerTagsResponseToJSON,
  ShopifyHealthcheckRequestFromJSON,
  ShopifyHealthcheckRequestToJSON,
  ShopifyHealthcheckResultFromJSON,
  ShopifyHealthcheckResultToJSON,
  ShopifyMetafieldDiscoveryFromJSON,
  ShopifyMetafieldDiscoveryToJSON,
  ShopifyStoreLocationsRequestFromJSON,
  ShopifyStoreLocationsRequestToJSON,
  ShopifyStoreLocationsResponseFromJSON,
  ShopifyStoreLocationsResponseToJSON,
  TestIntegrationRequestFromJSON,
  TestIntegrationRequestToJSON,
  TestIntegrationResponseFromJSON,
  TestIntegrationResponseToJSON,
  TestNetSuiteConnectionRequestFromJSON,
  TestNetSuiteConnectionRequestToJSON,
  UpdateBigCommerceFreightSettingsRequestFromJSON,
  UpdateBigCommerceFreightSettingsRequestToJSON,
  UpdateNetSuiteIntegrationRequestFromJSON,
  UpdateNetSuiteIntegrationRequestToJSON,
  UpdateShopifySettingsRequestFromJSON,
  UpdateShopifySettingsRequestToJSON,
} from "../models/index";

export interface ApproveBigCommerceOperationRequest {
  approveBigCommerceRequest: ApproveBigCommerceRequest;
}

export interface ApproveShopifyOperationRequest {
  approveShopifyRequest: ApproveShopifyRequest;
}

export interface BigCommerceCustomerGroupsRequest {
  integrationId: string;
}

export interface BigCommerceHealthcheckOperationRequest {
  bigCommerceHealthcheckRequest: BigCommerceHealthcheckRequest;
}

export interface BigCommerceProductsRequest {
  integrationId: string;
  search: string;
}

export interface CreateNetSuiteIntegrationOperationRequest {
  createNetSuiteIntegrationRequest: CreateNetSuiteIntegrationRequest;
}

export interface DeleteIntegrationOperationRequest {
  deleteIntegrationRequest: DeleteIntegrationRequest;
}

export interface DisconnectBigCommerceOperationRequest {
  disconnectBigCommerceRequest: DisconnectBigCommerceRequest;
}

export interface DiscoverShopifyMetafieldsOperationRequest {
  discoverShopifyMetafieldsRequest: DiscoverShopifyMetafieldsRequest;
}

export interface PreviewConfigRepairRequest {
  repairConfigRequest: RepairConfigRequest;
}

export interface RepairConfigOperationRequest {
  repairConfigRequest: RepairConfigRequest;
}

export interface ReplaceNetSuiteCredentialsOperationRequest {
  replaceNetSuiteCredentialsRequest: ReplaceNetSuiteCredentialsRequest;
}

export interface ShopifyCustomerTagsOperationRequest {
  shopifyCustomerTagsRequest: ShopifyCustomerTagsRequest;
}

export interface ShopifyHealthcheckOperationRequest {
  shopifyHealthcheckRequest: ShopifyHealthcheckRequest;
}

export interface ShopifyLocationsRequest {
  shopifyStoreLocationsRequest: ShopifyStoreLocationsRequest;
}

export interface TestIntegrationOperationRequest {
  testIntegrationRequest: TestIntegrationRequest;
}

export interface TestNetSuiteConnectionOperationRequest {
  testNetSuiteConnectionRequest: TestNetSuiteConnectionRequest;
}

export interface UpdateBigCommerceSettingsRequest {
  updateBigCommerceFreightSettingsRequest: UpdateBigCommerceFreightSettingsRequest;
}

export interface UpdateNetSuiteIntegrationOperationRequest {
  updateNetSuiteIntegrationRequest: UpdateNetSuiteIntegrationRequest;
}

export interface UpdateShopifySettingsOperationRequest {
  updateShopifySettingsRequest: UpdateShopifySettingsRequest;
}

/**
 *
 */
export class IntegrationsApi extends runtime.BaseAPI {
  /**
   */
  async approveBigCommerceRaw(
    requestParameters: ApproveBigCommerceOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MaskedCompanyIntegration>> {
    if (requestParameters["approveBigCommerceRequest"] == null) {
      throw new runtime.RequiredError(
        "approveBigCommerceRequest",
        'Required parameter "approveBigCommerceRequest" was null or undefined when calling approveBigCommerce().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/approve-bigcommerce`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ApproveBigCommerceRequestToJSON(
          requestParameters["approveBigCommerceRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MaskedCompanyIntegrationFromJSON(jsonValue),
    );
  }

  /**
   */
  async approveBigCommerce(
    requestParameters: ApproveBigCommerceOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MaskedCompanyIntegration> {
    const response = await this.approveBigCommerceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async approveShopifyRaw(
    requestParameters: ApproveShopifyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MaskedCompanyIntegration>> {
    if (requestParameters["approveShopifyRequest"] == null) {
      throw new runtime.RequiredError(
        "approveShopifyRequest",
        'Required parameter "approveShopifyRequest" was null or undefined when calling approveShopify().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/approve-shopify`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ApproveShopifyRequestToJSON(
          requestParameters["approveShopifyRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MaskedCompanyIntegrationFromJSON(jsonValue),
    );
  }

  /**
   */
  async approveShopify(
    requestParameters: ApproveShopifyOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MaskedCompanyIntegration> {
    const response = await this.approveShopifyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The store\'s customer groups for the exceptions pickers (ENG-7222), from the same lookup the merchant\'s app uses, so both offer the same choices and word a failure the same way. A GET, as is the product search below, because Hubble refetches the page after any other method: a POST here would reload the company page behind the dialog on every search.
   * The store\'s customer groups for the exceptions pickers (ENG-7222), from the same lookup the merchant\'s app uses, so both offer the same choices and word a failure the same way.
   */
  async bigCommerceCustomerGroupsRaw(
    requestParameters: BigCommerceCustomerGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BigCommerceCustomerGroupsResponse>> {
    if (requestParameters["integrationId"] == null) {
      throw new runtime.RequiredError(
        "integrationId",
        'Required parameter "integrationId" was null or undefined when calling bigCommerceCustomerGroups().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["integrationId"] != null) {
      queryParameters["integrationId"] = requestParameters["integrationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/integrations/bigcommerce-customer-groups`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BigCommerceCustomerGroupsResponseFromJSON(jsonValue),
    );
  }

  /**
   * The store\'s customer groups for the exceptions pickers (ENG-7222), from the same lookup the merchant\'s app uses, so both offer the same choices and word a failure the same way. A GET, as is the product search below, because Hubble refetches the page after any other method: a POST here would reload the company page behind the dialog on every search.
   * The store\'s customer groups for the exceptions pickers (ENG-7222), from the same lookup the merchant\'s app uses, so both offer the same choices and word a failure the same way.
   */
  async bigCommerceCustomerGroups(
    requestParameters: BigCommerceCustomerGroupsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BigCommerceCustomerGroupsResponse> {
    const response = await this.bigCommerceCustomerGroupsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Diagnoses one BigCommerce store the same way: a named check per prerequisite, with what we saw (ENG-7381). Read-only --- it never subscribes, writes config, or stamps the row\'s health.
   * Diagnoses one BigCommerce store the same way: a named check per prerequisite, with what we saw (ENG-7381).
   */
  async bigCommerceHealthcheckRaw(
    requestParameters: BigCommerceHealthcheckOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BigCommerceHealthcheckResult>> {
    if (requestParameters["bigCommerceHealthcheckRequest"] == null) {
      throw new runtime.RequiredError(
        "bigCommerceHealthcheckRequest",
        'Required parameter "bigCommerceHealthcheckRequest" was null or undefined when calling bigCommerceHealthcheck().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/bigcommerce-healthcheck`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: BigCommerceHealthcheckRequestToJSON(
          requestParameters["bigCommerceHealthcheckRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BigCommerceHealthcheckResultFromJSON(jsonValue),
    );
  }

  /**
   * Diagnoses one BigCommerce store the same way: a named check per prerequisite, with what we saw (ENG-7381). Read-only --- it never subscribes, writes config, or stamps the row\'s health.
   * Diagnoses one BigCommerce store the same way: a named check per prerequisite, with what we saw (ENG-7381).
   */
  async bigCommerceHealthcheck(
    requestParameters: BigCommerceHealthcheckOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BigCommerceHealthcheckResult> {
    const response = await this.bigCommerceHealthcheckRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Products matching a search, for the excluded-products picker.
   * Products matching a search, for the excluded-products picker.
   */
  async bigCommerceProductsRaw(
    requestParameters: BigCommerceProductsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BigCommerceProductSearchResponse>> {
    if (requestParameters["integrationId"] == null) {
      throw new runtime.RequiredError(
        "integrationId",
        'Required parameter "integrationId" was null or undefined when calling bigCommerceProducts().',
      );
    }

    if (requestParameters["search"] == null) {
      throw new runtime.RequiredError(
        "search",
        'Required parameter "search" was null or undefined when calling bigCommerceProducts().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["integrationId"] != null) {
      queryParameters["integrationId"] = requestParameters["integrationId"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/integrations/bigcommerce-products`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BigCommerceProductSearchResponseFromJSON(jsonValue),
    );
  }

  /**
   * Products matching a search, for the excluded-products picker.
   * Products matching a search, for the excluded-products picker.
   */
  async bigCommerceProducts(
    requestParameters: BigCommerceProductsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BigCommerceProductSearchResponse> {
    const response = await this.bigCommerceProductsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async createNetSuiteIntegrationRaw(
    requestParameters: CreateNetSuiteIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["createNetSuiteIntegrationRequest"] == null) {
      throw new runtime.RequiredError(
        "createNetSuiteIntegrationRequest",
        'Required parameter "createNetSuiteIntegrationRequest" was null or undefined when calling createNetSuiteIntegration().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/create-netsuite-integration`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreateNetSuiteIntegrationRequestToJSON(
          requestParameters["createNetSuiteIntegrationRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createNetSuiteIntegration(
    requestParameters: CreateNetSuiteIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createNetSuiteIntegrationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteIntegrationRaw(
    requestParameters: DeleteIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["deleteIntegrationRequest"] == null) {
      throw new runtime.RequiredError(
        "deleteIntegrationRequest",
        'Required parameter "deleteIntegrationRequest" was null or undefined when calling deleteIntegration().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/delete-integration`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DeleteIntegrationRequestToJSON(
          requestParameters["deleteIntegrationRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteIntegration(
    requestParameters: DeleteIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteIntegrationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async disconnectBigCommerceRaw(
    requestParameters: DisconnectBigCommerceOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MaskedCompanyIntegration>> {
    if (requestParameters["disconnectBigCommerceRequest"] == null) {
      throw new runtime.RequiredError(
        "disconnectBigCommerceRequest",
        'Required parameter "disconnectBigCommerceRequest" was null or undefined when calling disconnectBigCommerce().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/disconnect-bigcommerce`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DisconnectBigCommerceRequestToJSON(
          requestParameters["disconnectBigCommerceRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MaskedCompanyIntegrationFromJSON(jsonValue),
    );
  }

  /**
   */
  async disconnectBigCommerce(
    requestParameters: DisconnectBigCommerceOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MaskedCompanyIntegration> {
    const response = await this.disconnectBigCommerceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Lists the metafields a merchant\'s Shopify store actually carries, plus a proposed dimension mapping, so ops can fill in the dimension-metafield settings from real data rather than guessing key names (ENG-6356). Read-only --- the suggestion is never applied automatically.
   * Lists the metafields a merchant\'s Shopify store actually carries, plus a proposed dimension mapping, so ops can fill in the dimension-metafield settings from real data rather than guessing key names (ENG-6356).
   */
  async discoverShopifyMetafieldsRaw(
    requestParameters: DiscoverShopifyMetafieldsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShopifyMetafieldDiscovery>> {
    if (requestParameters["discoverShopifyMetafieldsRequest"] == null) {
      throw new runtime.RequiredError(
        "discoverShopifyMetafieldsRequest",
        'Required parameter "discoverShopifyMetafieldsRequest" was null or undefined when calling discoverShopifyMetafields().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/discover-shopify-metafields`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: DiscoverShopifyMetafieldsRequestToJSON(
          requestParameters["discoverShopifyMetafieldsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShopifyMetafieldDiscoveryFromJSON(jsonValue),
    );
  }

  /**
   * Lists the metafields a merchant\'s Shopify store actually carries, plus a proposed dimension mapping, so ops can fill in the dimension-metafield settings from real data rather than guessing key names (ENG-6356). Read-only --- the suggestion is never applied automatically.
   * Lists the metafields a merchant\'s Shopify store actually carries, plus a proposed dimension mapping, so ops can fill in the dimension-metafield settings from real data rather than guessing key names (ENG-6356).
   */
  async discoverShopifyMetafields(
    requestParameters: DiscoverShopifyMetafieldsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShopifyMetafieldDiscovery> {
    const response = await this.discoverShopifyMetafieldsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getAllIntegrationsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CompanyIntegrations>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/integrations/get-all-integrations`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CompanyIntegrationsFromJSON(jsonValue),
    );
  }

  /**
   */
  async getAllIntegrations(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CompanyIntegrations> {
    const response = await this.getAllIntegrationsRaw(initOverrides);
    return await response.value();
  }

  /**
   * What repairing an unreadable config would reset, so Ops see it before anything changes. Read-only.
   * What repairing an unreadable config would reset, so Ops see it before anything changes.
   */
  async previewConfigRepairRaw(
    requestParameters: PreviewConfigRepairRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConfigRepairPreview>> {
    if (requestParameters["repairConfigRequest"] == null) {
      throw new runtime.RequiredError(
        "repairConfigRequest",
        'Required parameter "repairConfigRequest" was null or undefined when calling previewConfigRepair().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/preview-config-repair`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RepairConfigRequestToJSON(
          requestParameters["repairConfigRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConfigRepairPreviewFromJSON(jsonValue),
    );
  }

  /**
   * What repairing an unreadable config would reset, so Ops see it before anything changes. Read-only.
   * What repairing an unreadable config would reset, so Ops see it before anything changes.
   */
  async previewConfigRepair(
    requestParameters: PreviewConfigRepairRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConfigRepairPreview> {
    const response = await this.previewConfigRepairRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Repairs an unreadable config by resetting only the values that won\'t read. Answers with what it reset.
   * Repairs an unreadable config by resetting only the values that won\'t read.
   */
  async repairConfigRaw(
    requestParameters: RepairConfigOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConfigRepairPreview>> {
    if (requestParameters["repairConfigRequest"] == null) {
      throw new runtime.RequiredError(
        "repairConfigRequest",
        'Required parameter "repairConfigRequest" was null or undefined when calling repairConfig().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/repair-config`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: RepairConfigRequestToJSON(
          requestParameters["repairConfigRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ConfigRepairPreviewFromJSON(jsonValue),
    );
  }

  /**
   * Repairs an unreadable config by resetting only the values that won\'t read. Answers with what it reset.
   * Repairs an unreadable config by resetting only the values that won\'t read.
   */
  async repairConfig(
    requestParameters: RepairConfigOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConfigRepairPreview> {
    const response = await this.repairConfigRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async replaceNetSuiteCredentialsRaw(
    requestParameters: ReplaceNetSuiteCredentialsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["replaceNetSuiteCredentialsRequest"] == null) {
      throw new runtime.RequiredError(
        "replaceNetSuiteCredentialsRequest",
        'Required parameter "replaceNetSuiteCredentialsRequest" was null or undefined when calling replaceNetSuiteCredentials().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/replace-netsuite-credentials`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ReplaceNetSuiteCredentialsRequestToJSON(
          requestParameters["replaceNetSuiteCredentialsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async replaceNetSuiteCredentials(
    requestParameters: ReplaceNetSuiteCredentialsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.replaceNetSuiteCredentialsRaw(requestParameters, initOverrides);
  }

  /**
   * The tags in use on a store\'s customers, so ops pick from the merchant\'s own vocabulary rather than typing a tag from a phone call (ENG-6685). The same list the merchant sees in the embedded app, from the same connector call --- the two surfaces edit one setting, so offering different choices in each is how they drift apart. Read-only. Returns an empty list when the store hasn\'t granted \\`read_customers\\` yet, which the pickers treat as \"let them type\".
   * The tags in use on a store\'s customers, so ops pick from the merchant\'s own vocabulary rather than typing a tag from a phone call (ENG-6685).
   */
  async shopifyCustomerTagsRaw(
    requestParameters: ShopifyCustomerTagsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShopifyCustomerTagsResponse>> {
    if (requestParameters["shopifyCustomerTagsRequest"] == null) {
      throw new runtime.RequiredError(
        "shopifyCustomerTagsRequest",
        'Required parameter "shopifyCustomerTagsRequest" was null or undefined when calling shopifyCustomerTags().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/shopify-customer-tags`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ShopifyCustomerTagsRequestToJSON(
          requestParameters["shopifyCustomerTagsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShopifyCustomerTagsResponseFromJSON(jsonValue),
    );
  }

  /**
   * The tags in use on a store\'s customers, so ops pick from the merchant\'s own vocabulary rather than typing a tag from a phone call (ENG-6685). The same list the merchant sees in the embedded app, from the same connector call --- the two surfaces edit one setting, so offering different choices in each is how they drift apart. Read-only. Returns an empty list when the store hasn\'t granted \\`read_customers\\` yet, which the pickers treat as \"let them type\".
   * The tags in use on a store\'s customers, so ops pick from the merchant\'s own vocabulary rather than typing a tag from a phone call (ENG-6685).
   */
  async shopifyCustomerTags(
    requestParameters: ShopifyCustomerTagsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShopifyCustomerTagsResponse> {
    const response = await this.shopifyCustomerTagsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Diagnoses one store\'s Shopify integration: a named pass/fail check per prerequisite, with the observed value (ENG-6394). Distinct from the scheduled canary in \\[net.freightsimple.tasks.scheduled.ShopifyIntegrationHealthCheck\\], which watches every store for liveness; this answers \"which of the prerequisites is wrong for \\*this\\* store\". Read-only --- it never registers, subscribes, or writes config.
   * Diagnoses one store\'s Shopify integration: a named pass/fail check per prerequisite, with the observed value (ENG-6394).
   */
  async shopifyHealthcheckRaw(
    requestParameters: ShopifyHealthcheckOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShopifyHealthcheckResult>> {
    if (requestParameters["shopifyHealthcheckRequest"] == null) {
      throw new runtime.RequiredError(
        "shopifyHealthcheckRequest",
        'Required parameter "shopifyHealthcheckRequest" was null or undefined when calling shopifyHealthcheck().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/shopify-healthcheck`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ShopifyHealthcheckRequestToJSON(
          requestParameters["shopifyHealthcheckRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShopifyHealthcheckResultFromJSON(jsonValue),
    );
  }

  /**
   * Diagnoses one store\'s Shopify integration: a named pass/fail check per prerequisite, with the observed value (ENG-6394). Distinct from the scheduled canary in \\[net.freightsimple.tasks.scheduled.ShopifyIntegrationHealthCheck\\], which watches every store for liveness; this answers \"which of the prerequisites is wrong for \\*this\\* store\". Read-only --- it never registers, subscribes, or writes config.
   * Diagnoses one store\'s Shopify integration: a named pass/fail check per prerequisite, with the observed value (ENG-6394).
   */
  async shopifyHealthcheck(
    requestParameters: ShopifyHealthcheckOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShopifyHealthcheckResult> {
    const response = await this.shopifyHealthcheckRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * The store\'s own locations, so a warehouse profile is picked rather than typed (ENG-7040). A warehouse is matched to a quoted origin by postal code, so a typed one with a typo reads as configured and changes no quote --- silently. Picking from the store\'s real list removes that, and names the warehouse whatever the merchant already calls it in their own admin. Only locations that fulfil online orders are returned: one that doesn\'t can never be the origin of a checkout rate request, so offering it would invite a profile that never matches. Locations with no postal code \\*are\\* returned, because that is exactly the case worth telling someone about. The same list the merchant sees in the embedded app, from the same connector call --- the two surfaces edit one setting, so offering different choices in each is how they drift apart. Read-only. Returns an empty list when Shopify can\'t be reached, which the pickers treat as \"let them type\".
   * The store\'s own locations, so a warehouse profile is picked rather than typed (ENG-7040).
   */
  async shopifyLocationsRaw(
    requestParameters: ShopifyLocationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShopifyStoreLocationsResponse>> {
    if (requestParameters["shopifyStoreLocationsRequest"] == null) {
      throw new runtime.RequiredError(
        "shopifyStoreLocationsRequest",
        'Required parameter "shopifyStoreLocationsRequest" was null or undefined when calling shopifyLocations().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/shopify-locations`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: ShopifyStoreLocationsRequestToJSON(
          requestParameters["shopifyStoreLocationsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShopifyStoreLocationsResponseFromJSON(jsonValue),
    );
  }

  /**
   * The store\'s own locations, so a warehouse profile is picked rather than typed (ENG-7040). A warehouse is matched to a quoted origin by postal code, so a typed one with a typo reads as configured and changes no quote --- silently. Picking from the store\'s real list removes that, and names the warehouse whatever the merchant already calls it in their own admin. Only locations that fulfil online orders are returned: one that doesn\'t can never be the origin of a checkout rate request, so offering it would invite a profile that never matches. Locations with no postal code \\*are\\* returned, because that is exactly the case worth telling someone about. The same list the merchant sees in the embedded app, from the same connector call --- the two surfaces edit one setting, so offering different choices in each is how they drift apart. Read-only. Returns an empty list when Shopify can\'t be reached, which the pickers treat as \"let them type\".
   * The store\'s own locations, so a warehouse profile is picked rather than typed (ENG-7040).
   */
  async shopifyLocations(
    requestParameters: ShopifyLocationsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShopifyStoreLocationsResponse> {
    const response = await this.shopifyLocationsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async testIntegrationRaw(
    requestParameters: TestIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TestIntegrationResponse>> {
    if (requestParameters["testIntegrationRequest"] == null) {
      throw new runtime.RequiredError(
        "testIntegrationRequest",
        'Required parameter "testIntegrationRequest" was null or undefined when calling testIntegration().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/test-integration`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: TestIntegrationRequestToJSON(
          requestParameters["testIntegrationRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TestIntegrationResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async testIntegration(
    requestParameters: TestIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TestIntegrationResponse> {
    const response = await this.testIntegrationRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async testNetSuiteConnectionRaw(
    requestParameters: TestNetSuiteConnectionOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<TestIntegrationResponse>> {
    if (requestParameters["testNetSuiteConnectionRequest"] == null) {
      throw new runtime.RequiredError(
        "testNetSuiteConnectionRequest",
        'Required parameter "testNetSuiteConnectionRequest" was null or undefined when calling testNetSuiteConnection().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/test-netsuite-connection`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: TestNetSuiteConnectionRequestToJSON(
          requestParameters["testNetSuiteConnectionRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      TestIntegrationResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async testNetSuiteConnection(
    requestParameters: TestNetSuiteConnectionOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<TestIntegrationResponse> {
    const response = await this.testNetSuiteConnectionRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateBigCommerceSettingsRaw(
    requestParameters: UpdateBigCommerceSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<BigCommerceConfig>> {
    if (requestParameters["updateBigCommerceFreightSettingsRequest"] == null) {
      throw new runtime.RequiredError(
        "updateBigCommerceFreightSettingsRequest",
        'Required parameter "updateBigCommerceFreightSettingsRequest" was null or undefined when calling updateBigCommerceSettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/update-bigcommerce-settings`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateBigCommerceFreightSettingsRequestToJSON(
          requestParameters["updateBigCommerceFreightSettingsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BigCommerceConfigFromJSON(jsonValue),
    );
  }

  /**
   */
  async updateBigCommerceSettings(
    requestParameters: UpdateBigCommerceSettingsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<BigCommerceConfig> {
    const response = await this.updateBigCommerceSettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async updateNetSuiteIntegrationRaw(
    requestParameters: UpdateNetSuiteIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["updateNetSuiteIntegrationRequest"] == null) {
      throw new runtime.RequiredError(
        "updateNetSuiteIntegrationRequest",
        'Required parameter "updateNetSuiteIntegrationRequest" was null or undefined when calling updateNetSuiteIntegration().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/update-netsuite-integration`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateNetSuiteIntegrationRequestToJSON(
          requestParameters["updateNetSuiteIntegrationRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateNetSuiteIntegration(
    requestParameters: UpdateNetSuiteIntegrationOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateNetSuiteIntegrationRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateShopifySettingsRaw(
    requestParameters: UpdateShopifySettingsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ShopifyConfig>> {
    if (requestParameters["updateShopifySettingsRequest"] == null) {
      throw new runtime.RequiredError(
        "updateShopifySettingsRequest",
        'Required parameter "updateShopifySettingsRequest" was null or undefined when calling updateShopifySettings().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/integrations/update-shopify-settings`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: UpdateShopifySettingsRequestToJSON(
          requestParameters["updateShopifySettingsRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ShopifyConfigFromJSON(jsonValue),
    );
  }

  /**
   */
  async updateShopifySettings(
    requestParameters: UpdateShopifySettingsOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ShopifyConfig> {
    const response = await this.updateShopifySettingsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
